import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { PublicationEndpoints } from 'src/client/publication/constants'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { PostType } from 'src/hook/usePosts'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { useUser } from 'src/hook/useUser'
import { UsePostImageProps } from './usePostImage.types'
import { DEFAULT_IMAGE_SIZE } from './usePostImage.constants'

const usePostImage = ({ post, enabled = true }: UsePostImageProps) => {
  const { authStatus } = useUser()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED
  const url = isUnauthenticated
    ? PublicationEndpoints.getPublicPostImage(post.id)
    : PublicationEndpoints.getPostImage(post.id)

  const imageDimension = {
    width: post.postType === PostType.URL ? DEFAULT_IMAGE_SIZE.width : post.mediaWidth,
    height: post.postType === PostType.URL ? DEFAULT_IMAGE_SIZE.height : post.mediaHeight
  }

  const response = useHotRequest<{ data: string }>(url, {
    cacheKey: [url],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SPARKLE,
    params: {
      redirect: false,
      ...(imageDimension?.width &&
        imageDimension?.height && {
          dimensions: `${imageDimension.width}x${imageDimension.height}`
        })
    },
    queryOptions: {
      enabled,
      ...DEFAULT_CACHE_CONFIG
    }
  })

  return {
    ...response,
    data: response?.data?.data,
    isLoading: enabled ? response.isLoading : false
  }
}

export default usePostImage
